module.exports = __webpack_public_path__ + "static/media/img-3.6ad040fa.jpg";